import React from 'react'
import { Route, RouteProps } from 'react-router-dom'

type Props = RouteProps & {}

const PrivateRoute: React.FC<Props> = (props) => {
  const { ...rest } = props

  return <Route {...rest} />
}

export default PrivateRoute
